import { createFileRoute, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/tracking")({
  head: () => ({ meta: [{ title: "Tracking & Pixels | Admin" }] }),
  component: lazyRouteComponent(() => import("@/pages-lazy/admin-tracking")),
});
